import { STAFF_CALENDAR } from "@/api_framework/api_config";
import {
  IStaffCalendarBookingDetailsResponseData,
  IStaffCalendarFilteSlotDetails,
} from "@/api_framework/api_modals/Calendar";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export type StaffCalendarBookingDetailsAPIErrorType = {
  status: boolean;
  message: string;
};

export const useStaffCalendarBookingDetailsAPI = () => {
  const [bookingDetails, setBookingDetails] = useState<IStaffCalendarFilteSlotDetails>(null);
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();

  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (bookingId: string) => {
      dispatch(
        setLoading({
          key: "isStaffCalendarBookingDetailsLoadingInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const baseURL = STAFF_CALENDAR?.STAFF_BOOKING_DETAILSAPI?.baseURL;
        const response: StaffCalendarBookingDetailsAPIErrorType = await axios
          .get(`${baseURL}${bookingId}/`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IStaffCalendarBookingDetailsResponseData>) => {
            dispatch(
              setLoading({
                key: "isStaffCalendarBookingDetailsLoadingInProgress",
                status: false,
              }),
            );
            if (res.data.status === true) {
              setBookingDetails(res.data.data);
              return { status: true, message: "ROTA_CREATED" };
            } else {
              setBookingDetails(null);
              return { status: false, message: "ROTA_NOT_CREATED" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isStaffCalendarBookingDetailsLoadingInProgress",
                status: false,
              }),
            );
            setBookingDetails(null);
            captureError(e);
            return { status: false, message: "ROTA_NOT_CREATED" };
          });
        return response;
      } catch (e: any) {
        const vv = e.response.data as any;

        toast.error("Server Error: " + e.message);

        return { status: false, message: vv.message };
      }
    },
    [dispatch],
  );
  return { bookingDetails, execute };
};
